import { MovieOpenPlayOutlineIcon } from './MovieOpenPlayOutlineIcon';

/**
 * author: Colton Wiscombe
 * id C855F888-FB96-40F5-9346-6B7A993C960A
 * name movie-open-play-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-play-outline.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardOpenPlayOutlineIcon = MovieOpenPlayOutlineIcon;
export default ClapperboardOpenPlayOutlineIcon